define('lib/validator/ValidatorIntlPhone',['require','lib/validator/ValidatorAbstract','Config'],function (require) {
	var ValidatorAbstract = require('lib/validator/ValidatorAbstract');
	var Config = require('Config');

	return ValidatorAbstract.extend({
		errorMap: {
			0: "Invalid number",
			1: "Invalid country code",
			2: "Too short",
			3: "Too long",
			4: "Invalid number",
			'-99': "error_value_is_empty"
		},

		options: {
			//iti.isValidNumber() only checks whether the number is a POSSIBLE length for the
			//region ("possible" mode internally) — a too-short number can still pass it.
			//isValidNumberPrecise() runs the library's actual (libphonenumber) validity check,
			//but is meaningfully stricter and could newly reject numbers that validate fine
			//today across many countries — opt in per field via `new ValidatorIntlPhone({strict:
			//true})` rather than changing the default everywhere until that's been reviewed.
			strict: false
		},

		validate: function (value) {
			value = value || '';
			//utils.js is loaded asynchronously (an ES module import()); iti.isValidNumber()/
			//getValidationError() throw synchronously via the library's own ensureUtils() guard
			//if called before that import resolves. The throwaway iti instance below isn't gated
			//on its own iti.promise, so building it and calling isValidNumber() right away used to
			//crash (and freeze whatever submit button called validate()) if the user pasted a
			//number and submitted before utils.js finished loading — most likely the very first
			//phone field validated on a page load. Only take that path once utils is confirmed
			//loaded; otherwise fall back to the same regex check used when the library isn't
			//loaded at all.
			if (window.intlTelInput && window.intlTelInput.utils) {
				const phoneInput = document.createElement("input");

				// window.loadUtilsFunction (the dynamic import() of utils.js) is normally
				// already defined by /v2/lib/intl-tel-input/js/load-utils.js, loaded as a
				// static <script src> in the public layout — a separate file, not part of
				// this RequireJS bundle, because r.js's parser cannot trace a literal
				// import() expression. Load it here too as a safety net in case the layout
				// script is missing for some reason.
				if(!window.loadUtilsFunction) {
					var loadUtilsScript = document.createElement('script');
					loadUtilsScript.src = '/v2/lib/intl-tel-input/js/load-utils.js';
					document.head.appendChild(loadUtilsScript);
				}

				const iti = window.intlTelInput(phoneInput, {
					initialCountry: this._getInitialCountry(),
					loadUtils: window.loadUtilsFunction,
					//allowedNumberTypes: null, //"FIXED_LINE_OR_MOBILE", (renamed from validationNumberTypes in v19+)
					//^ commented out on purpose (was forced to `null` = no type restriction, which
					//also disables the library's own MOBILE/FIXED_LINE length sanity check — this
					//is why implausibly short numbers, e.g. a German number missing most of its
					//digits, were accepted as "valid": with no type filter, isValidNumber()'s loose
					//"possible" check accepts far more than a real mobile/landline number could ever
					//be. Leaving this option unset restores the library's own default
					//(["MOBILE", "FIXED_LINE"]) instead of hardcoding a copy of it here.
					separateDialCode: false, //v29 default changed to true, keep previous look
				});
				iti.setNumber(value);

				var isValid = this.options.strict ? iti.isValidNumberPrecise() : iti.isValidNumber();
				if (!isValid && !_.isEmpty(value)) {
					this.handleValidationError(iti.getValidationError(), value);
				}
			} else {
				this.validateWithoutIntlTelInput(value);
			}

			if (!this.getErrors().length && this.options.allowedPrefix && !_.isEmpty(value)) {
				this.validatePrefix(value);
			}
		},

		handleValidationError: function (errorCode, value) {
			if (this.shouldIgnoreError(value)) return;

			var errorMsg = this.errorMap[errorCode] || this.errorMap[0];
			this.addError(errorMsg);
		},

		shouldIgnoreError: function (value) {
			return this.options.allowedPrefix && this.options.checkPhoneRequired && !this.isPhoneRequired() &&
				String(value).trim().replace('+', '') === this.options.allowedPrefix ||
				!this.isPhoneRequired() && _.isEmpty(String(value).trim());
		},

		validateWithoutIntlTelInput: function (value) {
			console.warn('intlTelInputUtils not loaded');
			var regexp = /^\+?[\d\s\-]{7,16}$/;
			if (!_.isEmpty(value) && !regexp.test(value)) {
				this.addError('error_value_is_not_phone');
			}
		},

		validatePrefix: function (value) {
			var prefix = String(this.options.allowedPrefix).replace(/^\D+/g, '');
			var phone = String(value).replace(/^\D+/g, '');
			if (phone.indexOf(prefix) !== 0) {
				this.addError("This country prefix not allowed");
			}
		},

		isPhoneRequired: function () {
			var config = Config.getInstance();
			var getParam = config.getParam || config.getOption;
			return config.getPluginStatus('client_login') ?
				parseInt(getParam('client_login_require_phone')) === 1 :
				getParam('client_phone_required');
		},

		//same fallback chain IntlPhone.js's _initIntl uses for the real widget — "auto" was
		//never actually functional here (intl-tel-input's IP-geolocation "auto" mode always
		//required a geoIpLookup function too, which this codebase never provided), so resolve
		//a real default country the same way the visible phone field already does.
		//@todo: if Config has no usable country value, consider a real geoIpLookup/
		//initialCountryLookup fallback (would need a client-callable IP-geolocation endpoint —
		//none exists yet, see lib/Notando/Service/{IpApi,MaxMind}.php, backend-only today)
		_getInitialCountry: function () {
			if (!Config || typeof Config.getInstance !== 'function') {
				return null;
			}
			var config = Config.getInstance();
			if (!config) {
				return null;
			}
			var getParam = config.getParam || config.getOption;
			if (typeof getParam !== 'function') {
				return null;
			}
			var initialCountry = getParam.call(config, 'country_phone_initial');
			if (initialCountry) {
				return String(initialCountry).toLowerCase();
			}
			var companyData = getParam.call(config, 'company') || getParam.call(config, 'company_data');
			if (companyData && companyData.country_id) {
				return String(companyData.country_id).toLowerCase();
			}
			return null;
		}
	});
});
